/**
 * Pseudo d'un apprenant sans e-mail (#271) : même règle que l'API
 * (`common/utils/username.ts`), vérifiée ici pour le dire avant l'envoi.
 */
const USERNAME_RE = /^[a-z0-9._-]{3,64}$/

/** Forme canonique : l'API enregistre le pseudo en minuscules, sans espaces autour. */
export function normalizeUsername(raw: string): string {
  return raw.trim().toLowerCase()
}

export function isValidUsername(raw: string): boolean {
  return USERNAME_RE.test(normalizeUsername(raw))
}

/** Clé i18n du refus de l'API pour un pseudo, un mot de passe ou la démo pleine (#350) ; `null` sinon. */
export function usernameErrorKey(message: string): string | null {
  if (message.includes('USERNAME_ALREADY_USED')) return 'user.username.taken'
  if (message.includes('INVALID_USERNAME')) return 'user.username.invalid'
  if (message.includes('PASSWORD_TOO_SHORT')) return 'user.password.tooShort'
  if (message.includes('PASSWORD_TOO_LONG')) return 'user.password.tooLong'
  if (message.includes('DEMO_LEARNER_LIMIT')) return 'demo.learnerLimit'
  return null
}
